import {
    apiRequest,
    bankList,
    bankActive,
    bankInactive
} from "../../../../../services/adapters/master/bankService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", bankList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", bankInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", bankActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository